import { getStage } from "./context";

export const showContractAddendum = getStage() !== "prod";
export const showCostAnalysisOptionTab = getStage() !== "prod";
export const showPrimaryCostCode = getStage() !== "prod";
